import {
    takeLatest, all, put, call,
} from 'redux-saga/effects';
import _ from 'lodash';
import Cookies from 'universal-cookie';
import API from '../common/API';
import * as Actions from '../actions/CompanyManagementOrganizer';
import { waitAuthorizedCheck } from './Auth';

function* getDetailCompanyOrganizer() {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const response = yield call(
            API.get,
            {
                endpoint: `/api/v1/event/${credential.data.event}/company/${credential.data.company_id}/`,
                token: credential.data.token,
            },
        );
        yield put(Actions.GetDetailCompanyOrganizerReceived(response));
    } catch (error) {
        yield put(Actions.GetDetailCompanyOrganizerReceivedFailure(yield error));
    }
}

function* editDetailCompanyOrganizer(action) {
    try {
        const credential = yield call(waitAuthorizedCheck);
        const response = yield call(
            API.putWithFile,
            {
                endpoint: `/api/v1/event/${credential.data.event}/company/${credential.data.company_id}/`,
                body: {
                    // ...(action.payload.company_full_name && { company_full_name: action.payload.company_full_name }),
                    // ...(action.payload.company_short_name && { company_short_name: action.payload.company_short_name }),
                    // ...(action.payload.company_type && { company_type: action.payload.company_type }),
                    // ...(action.payload.company_image && { company_image: action.payload.company_image }),
                    // ...(action.payload.first_name && { first_name: action.payload.first_name }),
                    // ...(action.payload.last_name && { last_name: action.payload.last_name }),
                    // ...(action.payload.zip_code && { zip_code: action.payload.zip_code }),
                    // ...(action.payload.address && { address: action.payload.address }),
                    // company_url: action.payload.company_url,
                    // company_description: action.payload.company_description,
                    // department: action.payload.department,
                    // position: action.payload.position,
                    // location: action.payload.location,
                    // phone_number: action.payload.phone_number,
                    // fax_number: action.payload.fax_number,
                    ...action.payload,
                },
                token: credential.data.token,
            },
        );
        yield put(Actions.EditCompanyOrganizerReceived(response));
    } catch (error) {
        yield put(Actions.EditCompanyOrganizerReceivedFailure(yield error));
    }
}

function* getCommonCompany(action) {
    const endpoint = action.payload?.language
        ? `/api/v1/company/${action.payload.companyId}/?language=${action.payload.language}`
        : `/api/v1/company/${action.payload}/`;
    try {
        const response = yield call(
            API.get,
            {
                endpoint,
            },
        );
        yield put(Actions.GetCommonInfoCompanyRequestedReceived(response));
    } catch (error) {
        yield put(Actions.GetCommonInfoCompanyRequestedReceivedFailure(yield error));
    }
}

function* getDetailCompanyOrganizerForSideBar() {
    try {
        const credential = yield call(waitAuthorizedCheck);
        if (!credential.data.company_id || credential.data.company_id === 'null') return;
        const response = yield call(
            API.get,
            {
                endpoint: `/api/v1/event/${credential.data.event}/company/${credential.data.company_id}/`,
                token: credential.data.token,
            },
        );
        yield put(Actions.GetDetailCompanyOrganizerForSideBarReceived(response));
    } catch (error) {
        yield put(Actions.GetDetailCompanyOrganizerForSideBarReceivedFailure(yield error));
    }
}

export default function* CompanyManagementOrganizer() {
    yield all([
        takeLatest('GET_DETAIL_COMPANY_ORGANIZER_REQUESTED', getDetailCompanyOrganizer),
        takeLatest('GET_DETAIL_COMPANY_ORGANIZER_FOR_SIDE_BAR_REQUESTED', getDetailCompanyOrganizerForSideBar),
        takeLatest('EDIT_COMPANY_ORGANIZER_REQUESTED', editDetailCompanyOrganizer),
        takeLatest('GET_COMMON_INFO_COMPANY_REQUESTED', getCommonCompany),
    ]);
}
